import { Form, Select } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

interface SelectAudienceListFiltersProps {
  audienceListId: string;
  value: string[];
  errors: any;
  isCampaignExist: boolean;
  showLabel?: boolean;
  onChange: (value: string[]) => void;
  getFilters: (params: any) => void;
  clearFilters: () => void;
}

export const SelectAudienceListFilters = ({ audienceListId, value, onChange, getFilters, errors, isCampaignExist, clearFilters, showLabel = true }: SelectAudienceListFiltersProps) => {
  const { filters, filtersLoading, filtersMetaData: { has_next } } = useSelector((state: any) => state.leads);
  const [currentPage, setCurrentPage] = useState(1);


  useEffect(() => {
    if (!isCampaignExist && audienceListId) {
      clearFilters();
      setCurrentPage(1);
      getFilters({ file_id: audienceListId, page: 1, page_size: 10 });
    } else {
      clearFilters();
      getFilters({ id__in: value });
    }
  }, [audienceListId]);

  const handlePopupScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { target } = e;
    const scrollElement = target as HTMLDivElement;
    const { scrollTop, scrollHeight, clientHeight } = scrollElement;
    const isBottom = scrollTop + clientHeight >= scrollHeight - 10;

    if (isBottom && has_next && !filtersLoading && !isCampaignExist) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      getFilters({
        file_id: audienceListId,
        page: nextPage,
      });
    }
  };

  return (
    <Form.Item name="audience_list_filters_ids" validateStatus={errors.audience_list_filters_ids ? 'error' : ''} help={errors.audience_list_filters_ids ? errors.audience_list_filters_ids?.toString() : ''} label={showLabel ? 'Filters:' : ''}>
      <Select
        placeholder="Select a filter for the audience list"
        value={value}
        defaultValue={value}
        disabled={isCampaignExist}
        onChange={onChange}
        optionLabelProp="label"
        mode="multiple"
        loading={filtersLoading}
        onPopupScroll={handlePopupScroll}
        options={filters.map((filter: any) => ({
          label: filter.name,
          value: filter.id,
        }))}
      />
    </Form.Item>
  )
}